export default __webpack_public_path__ + "static/media/Giftset.8c66e85f.jpg";